import { CourseSessionTheme, FmsOrganizationType } from '@fms/ts-gql-types';

export const LANDING_PAGE_SOURCE_STORAGE_KEY =
	'LANDING_PAGE_SOURCE_STORAGE_KEY';

export enum FmsCourseId {
	Citizen = 'cbf05401-5aa7-4929-ae0e-e5364b9bd1a6',
	Worklife = '48d92749-3c7f-4126-a75e-d724be512c9e',
}

export enum FmsNodeType {
	FmsUser = 'FmsUser',
	FmsCourse = 'FmsCourse',
	FmsCourseSession = 'FmsCourseSession',
	FmsMediaElement = 'FmsMediaElement',
	FmsSessionComponent = 'FmsSessionComponent',
	FmsUserAction = 'FmsUserAction',
	FmsEnrolment = 'FmsEnrolment',
}

export const fmsCourseThemes: CourseSessionTheme[] = [
	CourseSessionTheme.Strategies,
	CourseSessionTheme.Body,
	CourseSessionTheme.ThoughtsAndFeelings,
	CourseSessionTheme.SocialRelations,
	CourseSessionTheme.TheFocusYouWant,
];

export const fmsThemeIcons: { [key in CourseSessionTheme]: string } = {
	[CourseSessionTheme.Strategies]: 'fms_method_icon.svg',
	[CourseSessionTheme.Body]: 'fms_body_icon.svg',
	[CourseSessionTheme.ThoughtsAndFeelings]: 'fms_mind_icon.svg',
	[CourseSessionTheme.SocialRelations]: 'fms_human_intercourse_icon.svg',
	[CourseSessionTheme.TheFocusYouWant]: 'fms_meaning_icon.svg',
	[CourseSessionTheme.Other]: 'logo.png',
	[CourseSessionTheme.Unknown]: 'logo.png',
};

export const fmsThemeIconClasses: { [key in CourseSessionTheme]: string[] } = {
	[CourseSessionTheme.Strategies]: ['w-20', 'h-20'],
	[CourseSessionTheme.Body]: ['w-22', 'h-22', '-mt-2', 'pt-2'],
	[CourseSessionTheme.ThoughtsAndFeelings]: ['w-22', 'h-22', '-mt-2', 'pt-2'],
	[CourseSessionTheme.SocialRelations]: ['w-20', 'h-20'],
	[CourseSessionTheme.TheFocusYouWant]: ['w-20', 'h-20'],
	[CourseSessionTheme.Other]: ['w-20', 'h-20'],
	[CourseSessionTheme.Unknown]: ['w-20', 'h-20'],
};

export interface IFmsClientOrganization {
	type: FmsOrganizationType;
	id: FmsClientOrganizationId;
	label: string;
	allowForBoth: boolean;
}

export interface IFmsClientOrganization {
	type: FmsOrganizationType;
	id: FmsClientOrganizationId;
	label: string;
}

export enum FmsClientOrganizationId {
	FondenMentalSundhedBusiness = 'Business|41516178',
	FondenMentalSundhedMunicipality = 'Municipality|41516178',
	HeyLouise = 'Business|40442863',
	København = 'Municipality|101',
	BrandByHand = 'Business|36479388',
	Vertica = 'Business|26263573',
	Trifork = 'Business|20921897',
	Taarnby = 'Business|20310413',
	Duckwise = 'Business|33574398',
	SmartDevice = 'Business|38119206',
	Kombit = 'Business|19435975',
	HospitalKlovne = 'Business|27150632',
	GreenPeace = 'Business|89198313',
	Byplanlabo = 'Business|56736115',
	BKI = 'Business|56312412',
	Velliv = 'Business|FMS_Velliv',
	Arbejdsliv = 'Business|FMS_Arbejdsliv',
	Ledelse = 'Business|FMS_Ledelse',
	Aalborg = 'Municipaltiy|851',
	Skanderborg = 'Municipality|746',
	Mariager = 'Municipality|846',
	Sonderborg = 'Municipality|540',
	Rudersdal = 'Municipality|230',
	Gladsaxe = 'Municipality|159',
	Solrod = 'Municipality|269',
	Brondby = 'Municipality|153',
	HojeTaastrup = 'Municipality|169',
	SpringbraetAarhus = 'Business|58961914',
	EtAl = 'Business|36707836',
	OdenseUniversitetshospital = 'Business|29190909',
	FredericiaDagblad = 'Business|36503335',
	HK = 'Business|53250017',
	KøbenhavnBusiness = 'Business|101',
	GladsaxeBusiness = 'Business|159',
	CpProjektet = 'Course|0001',
	DM = 'Business|17542028',
	PFA = 'Business|13594376',
	Helsingor = 'Municipality|217',
	Fano = 'Municipality|563',
	FanoBusiness = 'Business|563',
	Hedensted = 'Municipality|773',
	Aarhus = 'Municipality|751',
	ENVS = 'Business|31119103',
	HagstovaForoyar = 'Business|FO_HagstovaForoya',
	Silkeborg = 'Municipality|740',
	StenoDiabetesCenter = 'Business|29190941', // CVR is Region Nordjylland (covers Nord and Midt)
}

export const fmsClientOrgOptions: Array<IFmsClientOrganization> = [
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.BKI,
		label: 'BKI Foods A/S',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.BrandByHand,
		label: 'Brand by Hand ApS',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.Ledelse,
		label: 'Bæredygtigt Ledelse',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.Arbejdsliv,
		label: 'Bæredygtigt Arbejdsliv',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.Byplanlabo,
		label: 'Dansk Byplanlaboratorium',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.HospitalKlovne,
		label: 'Dansk Hospitalsklovne',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.Duckwise,
		label: 'Duckwise A/S',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.FondenMentalSundhedBusiness,
		label: 'Fonden Mental Sundhed',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.GreenPeace,
		label: 'Greenpeace',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.HeyLouise,
		label: 'HeyLouise',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business, // Needs access to worklife course
		id: FmsClientOrganizationId.HojeTaastrup,
		label: 'Høje-Taastrup Kommune',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.Kombit,
		label: 'KOMBIT A/S',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.SmartDevice,
		label: 'Smart Device ApS',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.Trifork,
		label: 'Trifork A/S',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.Taarnby,
		label: 'Tårnby Kommune',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.Velliv,
		label: 'Velliv',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.Vertica,
		label: 'Vertica A/S',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Municipality,
		id: FmsClientOrganizationId.Aalborg,
		label: 'Aalborg Kommune',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Municipality,
		id: FmsClientOrganizationId.Gladsaxe,
		label: 'Gladsaxe Kommune',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Municipality,
		id: FmsClientOrganizationId.København,
		label: 'Københavns Kommune',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Municipality,
		id: FmsClientOrganizationId.Mariager,
		label: 'Mariager Kommune',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Municipality,
		id: FmsClientOrganizationId.Rudersdal,
		label: 'Rudersdal Kommune',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Municipality,
		id: FmsClientOrganizationId.Skanderborg,
		label: 'Skanderborg Kommune',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Municipality,
		id: FmsClientOrganizationId.Solrod,
		label: 'Solrød Kommune',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Municipality,
		id: FmsClientOrganizationId.Sonderborg,
		label: 'Sønderborg Kommune',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Municipality,
		id: FmsClientOrganizationId.FondenMentalSundhedMunicipality,
		label: 'Fonden Mental Sundhed',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Municipality,
		id: FmsClientOrganizationId.Brondby,
		label: 'Brøndby Kommune',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.SpringbraetAarhus,
		label: 'Springbræt Aarhus',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.EtAl,
		label: 'Et al',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.OdenseUniversitetshospital,
		label: 'Odense Universitetshospital',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.FredericiaDagblad,
		label: 'Fredericia Dagblad',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.HK,
		label: 'HK',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.KøbenhavnBusiness,
		label: 'Københavns Kommune',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Municipality,
		id: FmsClientOrganizationId.CpProjektet,
		label: 'CP-projektet',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.DM,
		label: 'DM',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.GladsaxeBusiness,
		label: 'Gladsaxe Kommune',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.PFA,
		label: 'PFA',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Municipality,
		id: FmsClientOrganizationId.Helsingor,
		label: 'Helsingør Kommune',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Municipality,
		id: FmsClientOrganizationId.Fano,
		label: 'Fanø Kommune',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.FanoBusiness,
		label: 'Fanø Kommune',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Municipality,
		id: FmsClientOrganizationId.Hedensted,
		label: 'Hedensted Kommune',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Municipality,
		id: FmsClientOrganizationId.Aarhus,
		label: 'Aarhus Kommune',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.ENVS,
		label: 'Aarhus Universitet - Institut for Miljøvidenskab',
		allowForBoth: true,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.HagstovaForoyar,
		label: 'Hagstova Føroya',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Municipality,
		id: FmsClientOrganizationId.Silkeborg,
		label: 'Silkeborg Kommune',
		allowForBoth: false,
	},
	{
		type: FmsOrganizationType.Business,
		id: FmsClientOrganizationId.StenoDiabetesCenter,
		label: 'Steno Diabetes Center',
		allowForBoth: true,
	},
];
